<template>
  <path
    d="M4 12.0002C4 12.5502 4.45 13.0002 5 13.0002H11C11.55 13.0002 12 12.5502 12 12.0002C12 11.4502 11.55 11.0002 11 11.0002H5C4.45 11.0002 4 11.4502 4 12.0002ZM19 18.0002H17V7.38018L14 8.40018V6.70018L18.7 5.00018H19V18.0002Z"
  />
</template>
